module.exports = __webpack_public_path__ + "img/delta.a5c7d247.png";